import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <div className="about-container" style={{ animation: 'fadeInUp 1s', animationFillMode: 'both' }}>
 {/* 顶部品牌区 */}
 <section style={{ padding: '0 0 2.5rem 0', background: 'none', margin: 0 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#222', letterSpacing: '0.01em', marginBottom: 12 }}>{t('about.title')}</h2>
          <div style={{ fontSize: '1.3rem', color: '#bfa14a', fontWeight: 500, marginBottom: 18, letterSpacing: '0.02em' }}>{t('about.slogan')}</div>
        </div>
      </section>
      {/* 分割线 */}
      <div style={{ width: 60, height: 4, background: '#bfa14a', borderRadius: 2, margin: '0 auto 2.5rem auto' }} />
      {/* 主体内容区 */}
      <section style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 18, boxShadow: '0 4px 32px rgba(0,0,0,0.04)', padding: '2.5rem 2vw', display: 'flex', alignItems: 'center', gap: '3.5rem', flexWrap: 'wrap' }}>
        {/* 左侧：公司介绍/理念 */}
        <div style={{ flex: '1 1 300px', minWidth: 260 }}>
          <div style={{
            fontSize: '1.13rem',
            color: '#444',
            lineHeight: 1.9,
            marginBottom: 18,
            whiteSpace: 'pre-line',
            letterSpacing: '0.01em',
            textAlign: 'justify',
          }}>{t('about.description')}</div>
        </div>
        {/* 右侧：LOGO大图 */}
        <div style={{ flex: '0 0 260px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src="/images/logo.jpg" alt="About Jieheng Stone" style={{ width: 220, height: 220, objectFit: 'contain', borderRadius: 18, boxShadow: '0 4px 24px rgba(191,161,74,0.08), 0 1.5px 8px rgba(0,0,0,0.06)', background: '#fff', padding: '1.5rem' }} />
        </div>
      </section>
      {/* 底部承诺区 */}
      <div style={{ maxWidth: 900, margin: '2.5rem auto 0 auto', textAlign: 'center', color: '#888', fontSize: 16, lineHeight: 1.7 }}>
        {t('footer.description')}
      </div>
      </div>

     
    </div>
  );
};

export default About; 